import * as React from "react";
import { IParagraphFeaturedDestinationsProps } from "./ParagraphFeaturedDestinationsProps";
import { Container } from "./ParagraphFeaturedDestinationsHelpers";
import { graphql } from "gatsby";
import FeaturedDestinations from "../../common/FeaturedDestinations/FeaturedDestinations";

const ParagraphFeaturedDestinations: React.FC<
  IParagraphFeaturedDestinationsProps
> = (props) => {
  return (
    <Container {...props}>
      <FeaturedDestinations {...props.node}></FeaturedDestinations>
    </Container>
  );
};
export const fragment = graphql`
  fragment ParagraphFeaturedDestinations on paragraph__featured_destinations {
    id
    parent_type
    field_title
    field_description
    field_subtitle
    relationships {
      field_destinations {
        relationships {
          city: field_city {
            name
            field_address {
              locality
            }
            path {
              alias
            }
          }
          media: field_media {
            relationships {
              image: field_media_image {
                gatsbyImage(
                  width: 195
                  height: 195
                  placeholder: BLURRED
                  layout: FIXED
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
        }
      }
    }
  }
`;
export default ParagraphFeaturedDestinations;
